module.exports = __webpack_public_path__ + "media/images/emblems/Gordola-coat_of_arms-aaed191d3a5181aede0941b8f952084c.svg";